import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react'
import { IoMdCloseCircle } from 'react-icons/io';
import { json, Link } from 'react-router-dom';
import { invertirFecha } from '../../../../tools/utils'
export default function ReserveCard ({reserva}){
//console.log(reserva)
const [traerModal, setTraerModal] = useState(false);
const [tarjetaElegida, setTarjetaElegida] = useState("V");
const [traerModalPagar, setTraerModalPagar] = useState(false);
const [loading, setLoading] = useState(false)



const handleValueModal = (value) => {
setTraerModal(value)
}

const handleTarjetaChange = (e) => {
    setTarjetaElegida(e.target.value);
  }


const handleAbrirVoucher = (idReserva) => {
        var dat = JSON.stringify(parseInt(idReserva));
            var losDatos =  btoa(dat);
           const url  = `http://pedrazaviajes.dyndns.org:5555/margaritan/php/dao/printVoucherReserva.php?idfg='+${losDatos}`;

            window.open(url, '_blank');
            
}



const PagarConFirsData = () => {
    setLoading(true);
    const fechaActual = new Date();
    const fechaFormateada = fechaActual.toISOString().split('T')[0];

    const nuevaReserva = {
        ...reserva,
        tarjetaElegida: tarjetaElegida,
        evento: {
            fecha: fechaFormateada
        },
        telefono: "0",
        email: ''
    };

    const data = {
        peticion: 48,
        reserva: nuevaReserva,
        importeAPagar: reserva.saldoReserva,
        callback: 'procesoCompra'
    };

    const url = `https://estanciamargarita.com.ar/backendBeta/php/servicios/serviciosCobranzas.php`;

    axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (response.data) {
            const link = document.createElement('a');
            link.href = response.data.data;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }).catch(error => {
        console.error(error);
    }).finally(() => {
        setLoading(false);
    });
}

    return (
        <>
        <div className="bg-gradient-to-br from-slate-100 via-amber-100 to-lime-200 shadow-xl rounded-xl p-6 mt-5 flex flex-col sm:flex-row items-start gap-6 border border-amber-400 items-center">
                
            
            
             <div className=' sm:ml-6 xl:ml-0'>
                <img src='/images/reserva/arbol.jpg' className='rounded-xl w-full sm:w-72 object-cover shadow-lg'  width="1216"
            height="640"/>
             </div>
             <div className="space-y-2 text-gray-800 text-center md:text-left">
                <h1 className='text-xl font-bold font-bebas'>Número de Reserva:  #{reserva.idReserva}</h1>
                <h1 className='text-xl font-bold font-bebas'>Fecha de salida:  {reserva?.evento.fecha ? invertirFecha(reserva.evento.fecha) : reserva.evento.fecha }</h1>
                <h1 className='text-xl font-bold font-bebas'>Total Reserva: ${reserva.totalReserva}</h1>
                <h1 className='text-xl font-bold font-bebas'>Total Cobrado: ${reserva.totalCobrado}</h1>
                <h1 className='text-xl font-bold font-bebas text-red-600'>Saldo Total: ${reserva.saldoReserva}</h1>
               
                <div className='md:flex-row flex flex-col gap-1 justify-center items-center content-center '>
                <button onClick={() => setTraerModal(true)} className='mt-4 px-4 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 text-white font-semibold'>
                  Ver Pasajeros
                </button>
                {traerModal && 
                            
                            <ModalPasajeros pasajeros={reserva.listaPasajeros} onValueModal={handleValueModal}/>
                                      }
                                      
                            {reserva.saldoReserva > 0 && (
                <button
                    className='mt-4 px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white font-semibold'
                    onClick={() => setTraerModalPagar(true)} >  PAGAR </button>
                )}
                {reserva.saldoReserva <= 0 ? <> <button className='mt-4 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold' onClick={() =>handleAbrirVoucher (reserva.idReserva)}> VOUCHER</button></>  : null }
                
                {/* <button className='font-bold rounded-lg text-sm uppercase w-40 h-16 bg-[#0f0f0f] text-[#ffffff] justify-center font-bebas'> EMITIR FACTURA</button> */}
             </div>
             </div>
        
    
</div>


{ traerModalPagar && 
             <div>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                
            <div className="bg-white p-6 rounded-lg sm:max-w-sm  m-10 md:m-0 w-full md:max-w-2xl text-center shadow-lg">
            <button onClick={()=> setTraerModalPagar(false)} className='flex justify-end'> <IoMdCloseCircle/> </button>
                   <select className="block w-full bg-gray-100 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" name="tarjeta" id="tarjeta" value={tarjetaElegida} onChange={handleTarjetaChange}>
                              <option value='0'>Seleccionar Tarjeta</option>
                              <option value="V">Visa</option>
                              <option value="M">Mastercard</option>
                              <option value="A">American Express</option>
                              <option value="D">Dinners</option>
                            </select>
                            <Link
                            onClick={(e) => {
                                if (loading) {
                                e.preventDefault();
                                } else {
                                PagarConFirsData();
                                }
                            }}
                            className={`mt-4 inline-block px-4 py-2 rounded-lg text-white font-semibold ${
                                loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
                            }`}
                            >
                            {loading ? 'Procesando...' : 'PAGAR'}
                            </Link>
                            </div>
                            </div>
                            </div>
                            }
        </>
    )
}

const ModalPasajeros = ({pasajeros, onValueModal}) => {
   
return (
    <div>
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            
        <div className="bg-white p-6 rounded-lg sm:max-w-sm  m-10 md:m-0 w-full md:max-w-2xl text-center shadow-lg">
        <button onClick={()=> onValueModal(false)} className='flex justify-end'> <IoMdCloseCircle/> </button>
                            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                           
                        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                                <tr>
                                    <th scope="col" class="px-6 py-3 bg-gray-50 dark:bg-gray-800">
                                        Nombre
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Apellido
                                    </th>
                                    <th scope="col" class="px-6 py-3 bg-gray-50 dark:bg-gray-800">
                                        P.Embarque
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Horario
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
        pasajeros.map((pasajero, index) => {
                        return (
                            <tr class="border-b border-gray-200 dark:border-gray-700">
                                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                                   {pasajero.nombre}
                                </th>
                                <td class="px-6 py-4">
                                   {pasajero.apellido}
                                </td>
                                <td class="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                                    {pasajero.direccionFull}
                                </td>
                                <td class="px-6 py-4">
                                   {pasajero.fechaHoraEmbarque}
                                </td>
                            </tr>
                            )}
                         )} </tbody>
                            </table>
                            </div>
                       
                            </div>
                            </div>
                        </div>
)
}
